import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BigIntBaseEntity } from './base.entity';
import { EmailRecordFolderEntity } from './email-record-folder.entity';
import { EmailSourceEntity } from './email-source.entity';

@Entity('email_folder')
@Index(['emailSourceId', 'name', 'parentFolderId'], { unique: true })
@Index(['emailSourceId', 'externalId'], { unique: true })
export class EmailFolderEntity extends BigIntBaseEntity {
	@Column({ name: 'fk_email_source__id', type: 'int', unsigned: true })
	public emailSourceId!: number;

	@ManyToOne(() => EmailSourceEntity, (source) => source.folders)
	@JoinColumn({ name: 'fk_email_source__id' })
	public emailSource!: EmailSourceEntity;

	@Column({ type: 'varchar', length: 255 })
	public name!: string;

	@Column({
		name: 'external_id',
		type: 'varchar',
		length: 255,
		charset: 'utf8mb4',
		collation: 'utf8mb4_0900_as_cs',
	})
	public externalId!: string;

	@Column({
		name: 'fk_email_folder__id',
		type: 'bigint',
		unsigned: true,
		nullable: true,
	})
	public parentFolderId?: string;

	@ManyToOne(() => EmailFolderEntity, (folder) => folder.childFolders, {
		nullable: true,
	})
	@JoinColumn({ name: 'fk_email_folder__id' })
	public parentFolder?: EmailFolderEntity;

	@OneToMany(() => EmailFolderEntity, (folder) => folder.parentFolder)
	public childFolders!: EmailFolderEntity[];

	@Column({ name: 'display_path', type: 'varchar', length: 255 })
	public displayPath!: string;

	@Column({
		name: 'sync_cursor',
		type: 'varchar',
		length: 2048,
		nullable: true,
		charset: 'utf8mb4',
		collation: 'utf8mb4_0900_as_cs',
	})
	public syncCursor?: string;

	@Column({ name: 'last_event_date', type: 'timestamp', nullable: true })
	public lastEventDate?: Date;

	@Column({
		name: 'processing_state',
		type: 'varchar',
		length: 50,
		nullable: true,
	})
	public processingState?: string;

	@Column({ name: 'processing_start_date', type: 'timestamp', nullable: true })
	public processingStartDate?: Date;

	@Column({ name: 'last_error', type: 'text', nullable: true })
	public lastError?: string;

	@OneToMany(() => EmailRecordFolderEntity, (link) => link.emailFolder)
	public recordLinks!: EmailRecordFolderEntity[];
}
